import React from "react";

const TimerClock = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill={fill}
            fillRule="evenodd"
            d="M11.92.365a15.238 15.238 0 0 1 18.53 15.77 1.524 1.524 0 1 1-3.043-.179 12.19 12.19 0 1 0-10.229 11.317 1.524 1.524 0 1 1 .485 3.009A15.237 15.237 0 0 1 11.921.364Z"
            clipRule="evenodd"
        />
        <path
            fill={fill}
            fillRule="evenodd"
            d="M15.238 6.095c.842 0 1.524.683 1.524 1.524v6.988l4.125 4.125a1.524 1.524 0 1 1-2.155 2.155l-4.571-4.571a1.524 1.524 0 0 1-.446-1.078V7.62c0-.841.682-1.524 1.523-1.524ZM26.75 20.065c.7.467.89 1.413.423 2.113l-1.468 2.203h3.248a1.524 1.524 0 0 1 1.267 2.369l-3.047 4.571a1.524 1.524 0 0 1-2.536-1.69l1.468-2.203h-3.248a1.524 1.524 0 0 1-1.267-2.369l3.047-4.57c.467-.701 1.413-.89 2.113-.424Z"
            clipRule="evenodd"
        />
    </svg>
);

export default TimerClock;